var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.appUser)?_c('v-app',{staticStyle:{"background-color":"white"}},[_c('RescueReport')],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }